import { useQuery } from "react-query";

import { RQ_KEY } from "../../constants/query";
import { getFederation } from "../../services/federations";
import { TFederationSimple } from "../schemas/federation";

export default function useQueryFederationId(id: string) {
  return useQuery<TFederationSimple, Error>([RQ_KEY.FEDERATION], () => getFederation(id));
}
